<template lang="pug">
  footer#foot
    p Because Trump is 💩,&nbsp;
      | <slot>Seriously, WTF</slot>
      a.top(@click="scrollUp" id="scroller" href="#ftl" :class="{'show': showScroll}")
        icon(name="arrow-up" scale="1")
</template>

<script>

import SmoothScroll from 'smooth-scroll'

export default {
  name: 'footer',
  data () {
    return {
      showScroll: false
    }
  },
  methods: {
    scrollUp (e) {
      e.preventDefault()
      const scroll = new SmoothScroll()
      const anchor = document.querySelector('#scroller')
      const toggle = document.querySelector('#ftl')
      const options = { speed: 1000, easing: 'easeOutCubic' }
      scroll.animateScroll(anchor, toggle, options)
    },
    handleScroll () {
      var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
      if (scrollTop > 100) {
        this.showScroll = true
      } else {
        this.showScroll = false
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="stylus">
  a.top
    transition all 300ms linear
    opacity 0
    text-shadow 0px 0px 2px black
    position fixed
    bottom 10px
    right 10px
    padding 0.2rem
    display: block
    text-align center
    border-radius: 2px
    &.show
      opacity 1
  #foot
    position fixed
    left 0
    bottom 0
    width 100vw
    text-align center
    background rgba(255, 255, 255, 0.92)
    border-top 2px dotted rgba(0, 0, 0, 0.2)
    b
      padding-top: 0.5rem
      display: block
      padding 0.5rem 0 0 0.5rem
      @media screen and (min-width: 440px)
        display: inline
        padding-top: 0
</style>



// WEBPACK FOOTER //
// Footer.vue?832b8634